import { Check } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { money } from "@/components/simple/product/Fields";

/** Screen 6 — the full master catalog as photo cards, all checked; tap to uncheck. */
export function StepProducts({ catalog, off, setOff, stripeNote }) {
    const toggle = (slug) => setOff((s) => (s.includes(slug) ? s.filter((x) => x !== slug) : [...s, slug]));
    const groupSlugs = (g) => catalog.products.filter((p) => p.group === g).map((p) => p.slug);
    const groupOn = (g) => groupSlugs(g).some((s) => !off.includes(s));
    const toggleGroup = (g) => {
        const slugs = groupSlugs(g);
        setOff((s) => (groupOn(g) ? [...new Set([...s, ...slugs])] : s.filter((x) => !slugs.includes(x))));
    };
    const chosen = catalog.products.length - off.length;
    return (
        <div className="space-y-6">
            {stripeNote && <p className="border border-ink px-3 py-2 text-[15px]" data-testid="signup-stripe-status">{stripeNote}</p>}
            <p className="text-[15px] text-muted-ink" data-testid="signup-products-count">
                {chosen} of {catalog.products.length} products chosen. Prices start at 13thav's standard price with no markup — change any of them later in Products.
                DTF gang sheets and transfers are on every shop.
            </p>
            {catalog.groups.map((g) => (
                <section key={g.key} data-testid={`signup-group-${g.key}`}>
                    <div className="flex items-center justify-between border-b border-ink pb-1">
                        <h2 className="text-[18px] font-semibold">{g.label}</h2>
                        <button type="button" onClick={() => toggleGroup(g.key)} className="min-h-[44px] text-[14px] underline"
                            data-testid={`signup-group-toggle-${g.key}`}>{groupOn(g.key) ? "Uncheck all" : "Check all"}</button>
                    </div>
                    <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
                        {catalog.products.filter((p) => p.group === g.key).map((p) => {
                            const on = !off.includes(p.slug);
                            return (
                                <button key={p.slug} type="button" onClick={() => toggle(p.slug)} aria-pressed={on}
                                    data-testid={`signup-product-${p.slug}`}
                                    className={`relative flex flex-col border text-left ${on ? "border-2 border-ink" : "border-line opacity-60"}`}>
                                    <span className="relative block aspect-square w-full overflow-hidden bg-[#f5f5f5]">
                                        {p.image && <img src={mediaUrl(p.image)} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-contain" />}
                                        <span className={`absolute right-1 top-1 flex h-6 w-6 items-center justify-center border border-ink ${on ? "bg-ink text-[#fff]" : "bg-white"}`}>
                                            {on && <Check size={14} />}
                                        </span>
                                    </span>
                                    <span className="px-2 pt-1 text-[14px] font-semibold leading-tight">{p.name}</span>
                                    <span className="px-2 pb-2 text-[13px] text-muted-ink">from {money(p.price)}</span>
                                </button>
                            );
                        })}
                    </div>
                </section>
            ))}
        </div>
    );
}

function Switch({ on, onChange, testid, label }) {
    return (
        <button type="button" role="switch" aria-checked={on} aria-label={label} onClick={() => onChange(!on)} data-testid={testid}
            className={`relative h-[28px] w-[52px] shrink-0 border border-ink ${on ? "bg-ink" : "bg-white"}`}>
            <span className={`absolute top-[3px] h-[20px] w-[20px] border border-ink bg-white transition-[left] ${on ? "left-[27px]" : "left-[3px]"}`} />
        </button>
    );
}

/** Screen 7 — the chosen products as rows with the "13thav prints" switch, all ON. No price fields. */
export function StepConsignment({ catalog, off, consignOff, setConsignOff }) {
    const rows = catalog.products.filter((p) => !off.includes(p.slug));
    const offHere = consignOff.filter((s) => rows.some((p) => p.slug === s));
    const allOn = offHere.length === 0;
    const setAll = (on) => setConsignOff(on ? [] : rows.map((p) => p.slug));
    const flip = (slug, on) => setConsignOff((s) => (on ? s.filter((x) => x !== slug) : [...new Set([...s, slug])]));
    return (
        <div className="space-y-4">
            <p className="text-[15px]" data-testid="signup-consign-promise">{catalog.promise}</p>
            <div className="flex items-center justify-between border border-ink px-3 py-2">
                <span className="text-[16px] font-semibold">13thav prints · {allOn ? "All on" : `${rows.length - offHere.length} of ${rows.length} on`}</span>
                <Switch on={allOn} onChange={setAll} testid="signup-consign-all" label="All on or all off" />
            </div>
            <ul className="divide-y divide-line border border-ink" data-testid="signup-consign-rows">
                {rows.map((p) => {
                    const on = !consignOff.includes(p.slug);
                    return (
                        <li key={p.slug} className="flex items-center gap-3 px-3 py-2" data-testid={`signup-consign-row-${p.slug}`}>
                            <div className="min-w-0 flex-1">
                                <p className="truncate text-[15px] font-semibold">{p.name}</p>
                                <p className="text-[13px] text-muted-ink" data-testid={`signup-consign-price-${p.slug}`}>
                                    {on ? `${money(p.price)} standard · markup 0` : `Your price ${money(p.price)} (set it in Products)`}
                                </p>
                            </div>
                            <Switch on={on} onChange={(v) => flip(p.slug, v)} testid={`signup-consign-${p.slug}`} label={`13thav prints ${p.name}`} />
                        </li>
                    );
                })}
            </ul>
            <p className="text-[14px] text-muted-ink">{catalog.promise_off}</p>
        </div>
    );
}
